// extracted by mini-css-extract-plugin
module.exports = {"UndoToast__undo":"vf_a vh_tj vh_gy"};